import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TipoViviendaService {
  private apiUrl =  `${environment.apiUrl}/api/viviendas`; 
  //private apiUrl = 'http://localhost:3000/api/viviendas';

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get(this.apiUrl, { withCredentials: true });
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  create(tipoVivienda: { nombre: string }): Observable<any> {
    return this.http.post(this.apiUrl, tipoVivienda, { withCredentials: true });
  }

  update(id: number, tipoVivienda: { nombre: string }): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, tipoVivienda, { withCredentials: true });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { withCredentials: true });
  }
}
